















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import ClientInjectorMixin from "@/mixins/clientInjectorMixin";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "child-accounts-listing-component": () =>
      import("@/components/app/global/client/childAccountsListingComp.vue")
  }
})
export default class AdminClientAccountsChildAccountView extends Mixins(
  ClientInjectorMixin
) {
  // Props

  @Prop({ required: true })
  public client!: IClient;
}
